import { selectLatestMarketValue, selectCurrentMarketTemperatureIndex } from '../../../store/selectors/marketRecord'
import history from '../../../history'
import { useSelector } from 'react-redux'
import { Button, StatusIcon } from '../..'
import { defineMessages, useIntl } from 'react-intl'
import MarketSpotlightText from './MarketSpotlightText'
import { Card, Flex } from '@homebotapp/hb-react-component-catalog'
import { OVERLAY_HELPERS } from '../../../constants/navigation'
import { useTrackingContext } from '../../../providers/tracking'
import { TrackingEventConstants } from '../../../constants/tracking'
import { MARKET_VALUE_BREAK_POINTS } from '../../../constants/marketRecords'

export const MSG = defineMessages({
  seeWhy: {
    id: 'General.seeWhy',
    defaultMessage: 'See why'
  }
})

export interface MarketSpotlightNavigatorProps {
  locked: boolean
}

export const MarketSpotlightNavigator = ({ locked }: MarketSpotlightNavigatorProps) => {
  const intl = useIntl()
  const { trackingClient } = useTrackingContext()
  const index = useSelector(selectCurrentMarketTemperatureIndex)
  const latestMarketValue = useSelector(selectLatestMarketValue)

  const fireAmpliMarketTempClicked = () => {
    if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.VERY_HIGH) {
      trackingClient?.marketTempClicked({
        market_temp_range: TrackingEventConstants.MARKET_TEMP_IN_HIGH_DEMAND
      })
    } else if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.HIGH) {
      trackingClient?.marketTempClicked({
        market_temp_range: TrackingEventConstants.MARKET_TEMP_IN_DEMAND
      })
    } else if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.MODERATE) {
      trackingClient?.marketTempClicked({
        market_temp_range: TrackingEventConstants.MARKET_TEMP_BALANCED
      })
    } else if (latestMarketValue > MARKET_VALUE_BREAK_POINTS.LOW) {
      trackingClient?.marketTempClicked({
        market_temp_range: TrackingEventConstants.MARKET_TEMP_COOLING_OFF
      })
    } else {
      trackingClient?.marketTempClicked({
        market_temp_range: TrackingEventConstants.MARKET_TEMP_COLD
      })
    }
  }

  const handleClick = () => {
    if (!locked) {
      fireAmpliMarketTempClicked()
      history.push(OVERLAY_HELPERS.marketSpotlight.buildPath())
    }
  }

  return (
    <Flex marginBottom={6} justify='center'>
      <Card padding={4}>
        {index ? (
          <>
            <MarketSpotlightText />
            <Button minimal onClick={handleClick} data-qa='take-a-look-btn'>
              {intl.formatMessage(MSG.seeWhy)}
            </Button>
          </>
        ) : (
          <StatusIcon spin />
        )}
      </Card>
    </Flex>
  )
}
